import styled, { css } from 'styled-components';

export const FiltersWrapper = styled.div`
  margin-block: 24px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  align-items: center;
  gap: 8px 24px;

  > div:first-child {
    grid-column-end: span 2;
  }

  .full-width {
    grid-column-end: span 6;
  }

  > button {
    grid-column-start: 6;
    margin-left: auto;
    height: 40px;
  }

  @media ${({ theme }) => theme.device.laptop} {
    grid-template-columns: repeat(3, 1fr);

    .full-width {
      grid-column-end: span 3;
    }

    > button {
      grid-column-start: 3;
    }
  }
`;

export const SortingWrapper = styled.div`
  margin-block: 24px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  > div:last-child {
    height: 48px;
  }
`;

const gridTempCols = css`
  --padding-inline: 24px;

  display: grid;
  column-gap: 24px;
  padding-inline: var(--padding-inline);

  @media ${({ theme }) => theme.device.mobileL} {
    --padding-inline: 0;
  }
`;

export const LegendAndCard = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['gridTemplateColumns', 'gridTemplateRows'].includes(prop),
})`
  &:not(:last-child) {
    margin-bottom: 8px;
  }

  > * {
    grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};

    @media ${({ theme }) => theme.device.mobileL} {
      grid-template-rows: ${({ gridTemplateRows }) => gridTemplateRows};
    }
  }

  @media ${({ theme }) => theme.device.mobileL} {
    display: flex;
    border-bottom: 1px solid #8b8b8b;
    padding-block: 16px;

    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

export const Legend = styled.div`
  ${gridTempCols}
  margin-bottom: 16px;

  > *:first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }

  > *:last-child {
    margin-right: calc(var(--padding-inline) * -1);
  }

  @media ${({ theme }) => theme.device.mobileL} {
    row-gap: 8px;
    grid-template-columns: 96px;
    align-items: center;
    margin-bottom: 0;

    > *:first-child {
      margin-left: 0;
    }

    > *:last-child {
      margin-right: 0;
    }

    //"Tipologia profilo"
    > *:nth-child(4) {
      white-space: nowrap;
    }
  }
`;

export const CardsWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['hasPaginator'].includes(prop),
})`
  padding-bottom: ${({ hasPaginator }) => (hasPaginator ? 48 : 64)}px;

  > div:last-child {
    margin-bottom: 0;
  }
`;

export const LogCard = styled.div`
  ${gridTempCols}
  align-items: center;
  height: 70px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);

  @media ${({ theme }) => theme.device.mobileL} {
    row-gap: 8px;
    grid-template-columns: 1fr;
    text-align: end;
    width: 100%;

    //remove card style
    height: auto;
    border-radius: 0;
    background: none;
    box-shadow: none;

    //"Descrizione log"
    > *:nth-child(1) {
      text-wrap: balance; //make it fancier
    }

    //"Tipologia profilo"
    > *:nth-child(4) {
      margin-left: 48px;
    }
  }
`;
